import { useEffect, useState } from "react";
import { api } from "../lib/api";

type Row = {
  rank: number;
  customer_id: number;
  name: string | null;
  total_punches: number;
  redemptions: number;
  customer_since: string | null;
};

export function Leaderboard() {
  const [rows, setRows] = useState<Row[]>([]);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    api<{ data: Row[] }>("/api/leaderboard").then((r) => setRows(r.data)).catch((e: Error) => setErr(e.message));
  }, []);
  return (
    <div>
      <h1 className="text-xl font-semibold mb-3">Leaderboard · top buyers</h1>
      {err && <div className="text-red-600 text-sm mb-3">{err}</div>}
      <ol className="bg-white border border-neutral-200 rounded-lg divide-y divide-neutral-100">
        {rows.length === 0 && <li className="px-4 py-6 text-center text-neutral-500">No data yet.</li>}
        {rows.map((r) => (
          <li key={r.customer_id} className="flex items-center gap-3 px-4 py-3">
            <span className={`w-7 h-7 inline-flex items-center justify-center rounded-full text-sm font-semibold ${
              r.rank === 1 ? "bg-yellow-200 text-yellow-900" :
              r.rank === 2 ? "bg-neutral-300 text-neutral-800" :
              r.rank === 3 ? "bg-orange-200 text-orange-900" :
              "bg-neutral-100 text-neutral-600"
            }`}>{r.rank}</span>
            <div className="flex-1">
              <div className="font-medium">{r.name ?? <span className="text-neutral-400 italic">no name</span>}</div>
              <div className="text-xs text-neutral-500">
                {r.redemptions} redemption{r.redemptions === 1 ? "" : "s"} · since {r.customer_since ?? "—"}
              </div>
            </div>
            <div className="text-right">
              <div className="font-semibold">{r.total_punches}</div>
              <div className="text-xs text-neutral-500">punches</div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
